module.exports = __webpack_public_path__ + "static/cisne-767f33b7bf42a02aabd7444846c9e5cb.jpg";